jQuery(document).ready(function($) {
    $(document).on('click', '.grid.product-grid input[type="radio"]', function(e) {
        var sectionId = $(this).data('section-id');
        var variantId = $(this).data('variant-id');
        var card = $(this).closest(`.card-product-custom-div[data-section-id="${sectionId}"]`);
        var variantDataMap = window['variantDataMap' + sectionId.replace(/-/g, '_')];
        var variantData = variantDataMap ? variantDataMap[variantId] : undefined;

        // Se variantData estiver vazio, tenta buscar os dados de outra forma
        if (!variantData) {
            // Inicializa alternativeVariantDataMap como um objeto vazio
            var alternativeVariantDataMap = {};

            // Busca todos os textareas de classe .dataTdzain e combina os JSONs
            $('.dataTdzain').each(function() {
                var jsonData = $(this).val();
                try {
                    var parsedData = JSON.parse(jsonData);
                    $.extend(alternativeVariantDataMap, parsedData);
                } catch (error) {
                    console.error("Erro ao parsear JSON: ", error);
                }
            });

            // Tenta encontrar a variante dentro dos dados combinados
            variantData = alternativeVariantDataMap[variantId];

            // Se ainda assim não encontrar os dados, loga a falha
            if (!variantData) {
                console.log('No data found for variant:', variantId, 'even after combining JSONs.');
                return;
            }
        }

        // Update the product image with lazy loading logic
        var productImageElement = card.find('.card__media img');
        if (productImageElement.length) {
            var lazyLoadAllVariants = card.data('lazy-load-all-variants') === true;
            if (lazyLoadAllVariants) {
                var preloadedImage = card.find(`img[data-variant-id="${variantId}"]`);
                if (preloadedImage.length) {
                    productImageElement.attr('src', preloadedImage.attr('src'));
                    productImageElement.attr('srcset', preloadedImage.attr('srcset'));
                } else {
                    console.log('Matching preloaded image not found for variant:', variantId);
                }
            } else {
                // Update src and srcset for responsive images
                var dynamicSrcset = [
                    variantData.imageUrl + '?width=165 165w',
                    variantData.imageUrl + '?width=360 360w',
                    variantData.imageUrl + '?width=533 533w',
                    variantData.imageUrl + '?width=720 720w',
                    variantData.imageUrl + '?width=940 940w',
                    variantData.imageUrl + '?width=1066 1066w'
                ].join(', ');
                productImageElement.attr('srcset', dynamicSrcset);
                productImageElement.attr('src', variantData.imageUrl);
            }
        } else {
            console.log('No product image element found in this card.');
        }
        
        // Update the product URL
        var productLinks = card.find('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]');
        productLinks.each(function() {
            $(this).attr('href', variantData.productUrl);
        });
    });
});
